import type {
	FormType,
	SubscriptionPeriod,
	SubscriptionPlan,
} from "../../types";

type Args = {
	cardData: {
		plan: SubscriptionPlan | null;
		period: SubscriptionPeriod;
	};
	navigate: (path: string) => void;
	setValue: (value: string) => void;
	context: { isAuthenticated: boolean } | null;
	setSelectedPlan: (plan: SubscriptionPlan | null) => void;
	setOpenModal: (modal: FormType | null) => void;
	stripeId: string | null;
	setAttemptToBuy: (attempt: boolean) => void;
};

export function handleClickOnCard(args: Args) {
	const {
		cardData,
		navigate,
		setValue,
		context,
		setSelectedPlan,
		setOpenModal,
		stripeId,
		setAttemptToBuy,
	} = args;

	if (!cardData.plan) {
		console.error("Plan is not selected");
		return;
	}

	if (!context?.isAuthenticated) {
		navigate("/login");
		setValue("/account#pricing");
		setAttemptToBuy(true);
		return;
	}

	setSelectedPlan(cardData.plan);

	if (!stripeId) {
		setOpenModal("address");
		return;
	}

	setOpenModal("preview");
}
